/**
 * Tab query indices for settings pages (`?tab=N`).
 * Must stay in sync with tab array order in `helpers.tsx`.
 */
export const GeneralTabIndex = {
    General: 0,
    Webhooks: 1,
    /** Admin-only; appended after GeneralTabs when `isAdmin`. */
    TmpFeatureFlags: 2,
} as const

export const BookingTabIndex = {
    Booking: 0,
    Branding: 1,
    Payments: 2,
} as const

export const EngagementTabIndex = {
    Communications: 0,
    AIReceptionist: 1,
    ChatStatuses: 2,
    CustomMergeTags: 3,
    Loyalty: 4,
    Reviews: 5,
} as const

/**
 * Sub-tabs inside Engagement Settings > AI Receptionist, read from the
 * `section` query param (`?tab=1&section=voice`). Missing or unknown values
 * open Instructions.
 */
export const AiReceptionistSection = {
    Instructions: 'instructions',
    VoiceAndSetup: 'voice',
} as const

export type AiReceptionistSectionId =
    (typeof AiReceptionistSection)[keyof typeof AiReceptionistSection]

export const AI_RECEPTIONIST_SECTION_QUERY_PARAM = 'section'

export const SyncTabIndex = {
    Sync: 0,
    AppointmentStatuses: 1,
    Products: 2,
    Sexes: 3,
    ReminderTypes: 4,
    Species: 5,
} as const
